import qs from 'query-string';
import { ParsedUrlQuery } from 'querystring';
import { SentryMinimal } from '@bridebook/toolbox/src/sentry';

const BRIDEBOOK_TAG_MANAGER_PREFIX = 'btm_';

export const generateReflinkUrl = <T extends Record<string, string>>(url: string, params: T) => {
  try {
    const [baseUrl, query] = url.split('?');

    const baseUrlWithoutTrailingSlash = baseUrl.replace(/\/$/, '');
    const tagManagerQuery = Object.entries(params)
      .map(
        ([key, value]) =>
          `${BRIDEBOOK_TAG_MANAGER_PREFIX}${encodeURIComponent(key)}=${encodeURIComponent(value)}`,
      )
      .join('&');
    return baseUrlWithoutTrailingSlash + '/?' + (query ? query + '&' : '') + tagManagerQuery;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('Error while generating ref url!');
    SentryMinimal().captureException(e, {
      tags: {
        source: 'reflinks',
      },
    });
    return url;
  }
};

export const getParamsFromReflinkUrl = (reflinkUrl: string) => {
  const url = new URL(reflinkUrl);
  const parsedQuery = qs.parse(url.search);
  return getReflinkParams(parsedQuery);
};

export const getReflinkParams = (query: qs.ParsedQuery | ParsedUrlQuery) => {
  let result = {};
  if (!query) return result;
  try {
    result = Object.keys(query)
      .filter((key) => key.startsWith(BRIDEBOOK_TAG_MANAGER_PREFIX))
      .reduce((acc, key) => {
        const keyWithouPrefix = key.slice(BRIDEBOOK_TAG_MANAGER_PREFIX.length);
        acc[keyWithouPrefix] = query[key];
        return acc;
      }, {} as Record<string, unknown>);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('Error while getting reflink params');
    SentryMinimal().captureException(e);
    result = {};
  }
  return result;
};
